/* eslint-disable */
import React from 'react';
import * as UI from "@material-ui/core";
import cn from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import type {FC} from 'react';
import { CalendarValueType, CalendarMultipleValueType, ICalendarSelectorComponentProps } from '../../../shared';
import DimSlider from '../../../shared/controls/DimSlider';
import DimToggle from '../../../shared/controls/DimToggle';
import { useStyles, SINGLE_SELECT_CLASS } from './SelectorStyles';
import messages from '../messages';
import CheckedIcon from '../../../../../icons/Checked';
import UncheckedIcon from '../../../../../icons/Unchecked';


type CalendarBASFSelectorHandlerType = (value: CalendarValueType | CalendarMultipleValueType) => void;
type CalendarBASFSelectorPropsType = ICalendarSelectorComponentProps & { closeOnSelect?: boolean; onClickGroup?: () => void; onChange: CalendarBASFSelectorHandlerType, inputRef?: HTMLInputElement, selectorMask?: (value: string) => string };

export const Selector: FC<CalendarBASFSelectorPropsType> = (props => { 
  const inputRef = props.inputRef;
  const intl = useIntl();
  const classes = useStyles(props);
  const { groups, currentGroup, multiple, openState, groupSize, closeOnSelect, disableApplay } = props;
  const { nextGroup, prevGroup, select, selectAll, unselectAll, applay, cancel, selectorMask, onClickGroup } = props;
  const countValuesInLastRow = currentGroup.items.length % groupSize;
  const applyButtonClasses = {
    root: classes.applyCancelButton,
    label: classes.selectButtonLabel
  };
  return React.useMemo(() => {
    return (
      <UI.Popover
        id="simple-popper"
        open={openState}
        anchorEl={inputRef}
        className={classes.root}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",

          horizontal: "left",
        }}
        transitionDuration={0}
      >
        <UI.ClickAwayListener onClickAway={props.onToggleOpenState}>
          <UI.Paper className={cn(classes.popperContent)}>
            <DimSlider
              onClick={onClickGroup}
              dimValues={groups}
              selectedIndex={groups.map(x => x.id).indexOf(currentGroup.id)}
              onNext={() => {
                if (nextGroup) nextGroup();
              }}
              onPrevious={() => {
                if (prevGroup) prevGroup();
              }}
            />
            <DimToggle
              key={`group-${currentGroup.id}`}
              selectionType={multiple ? "multiple" : "single"}
              dimValues={currentGroup.items.map(x => ({ id: x.item.id, name: selectorMask ? selectorMask(x.item.name) : x.item.name, disabled: x.disabled }))}
              onChange={(values) => { 
                select(values);
                if (!multiple && applay) {
                  applay();
                  if (closeOnSelect !== false) {
                    props.onToggleOpenState();
                  }
                }
              }}
              value={groups.flatMap(x => x.items).filter(x => x.active).map(x => x.item.id)}
              buttonClassName={cn(classes.button)}
              buttonActiveClassName={cn(classes.buttonActive)}
              className={cn(classes.periodSelector, {
                [classes.lastButtonFirst]: countValuesInLastRow === 1,
                [classes.lastButtonSecond]: countValuesInLastRow === 2,
                [classes.lastButtonThird]: countValuesInLastRow === 3,
              })}
            />
            <div className={cn(classes.buttonContainer)}>
              {multiple && <div className={cn(classes.selectButtonContainer)}>
                <UI.Button
                  className={classes.selectButton}
                  title={intl.formatMessage(messages.selectAllButtonLabel)}
                  color="default"
                  variant="text"
                  size="small"
                  onClick={selectAll || undefined}
                  disabled={!Boolean(selectAll) && !disableApplay}
                >
                  <CheckedIcon className={classes.selectButtonIcon} />
                </UI.Button>
                <UI.Button
                  className={classes.selectButton}
                  title={intl.formatMessage(messages.unselectAllButtonLabel)}
                  color="default"
                  variant="text"
                  size="small"
                  onClick={unselectAll || undefined}
                  disabled={!Boolean(unselectAll) && !disableApplay}
                >
                  <UncheckedIcon className={classes.selectButtonIcon} />
                </UI.Button>
              </div>
              }
              <div className={cn(classes.applyButtonContainer, {
                [SINGLE_SELECT_CLASS]: !multiple,
              })}>
                <UI.Button
                  classes={applyButtonClasses}
                  color="default"
                  variant="text"
                  size="small"
                  onClick={() => {
                    cancel();
                    if (props.onCancel) props.onCancel();
                    props.onToggleOpenState();
                  }}
                >
                  <FormattedMessage {...messages.cancelButtonLabel} />
                </UI.Button>
                {multiple &&
                  <UI.Button
                    classes={applyButtonClasses}
                    color="primary"
                    variant="text"
                    size="small"
                    onClick={() => {
                      if (applay) {
                        applay();
                        props.onToggleOpenState();
                      }
                    }}
                    disabled={!Boolean(applay) || disableApplay}
                  >
                    <FormattedMessage {...messages.apllyButtonLabel} />
                  </UI.Button>
                }
              </div>
            </div>
          </UI.Paper>
        </UI.ClickAwayListener>
      </UI.Popover>
    );
  }, [groups, currentGroup, multiple, openState, groupSize, nextGroup, prevGroup, select, selectAll, unselectAll, applay, closeOnSelect]);
});
